import React from 'react';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Label } from 'react-bootstrap';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import './style.scss';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import OrderTexts from '../OrderTexts';
import { export2Excel, filterNumber, getFilteredData, setDataForExpansion, getSum, getBoolColumn, getTextColumn, getNumberColumn, removeRow, getExpander } from '../../gridHelpers/gridHelpers';
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import * as Convert from '../.././util/unitConversion';

class OrderItems extends React.Component {
    constructor(props) {        
        super(props);
        this.state={
        data:props.data, 
        changedProdCodes:[], 
        currentExpand:'',
        expanded: {}, 
        page: 0,
        pageSize: 1000, 
        resized:[], 
        weightTotal: 0, 
        quantityTotal: 0,
        orderByType: window.sessionStorage.getItem("LegalEntity") === 'NP' ? [{label:'Weight',value:'W'}, {label:'Quantity',value:'Q'}, {label:'Meter',value:'M'}] : [{label:'Weight',value:'W'}, {label:'Quantity',value:'Q'}]
        };
        this.getcolumns=this.getcolumns.bind(this);
        this.addNewRow=this.addNewRow.bind(this);
        this.clearCurrentExpandforAll=this.clearCurrentExpandforAll.bind(this);
        this.getDeliverytimeMethod=this.getDeliverytimeMethod.bind(this);
        this.calcWeightOrQuantity=this.calcWeightOrQuantity.bind(this);
        this.updateDates=this.updateDates.bind(this);
        this.isSingleCode=this.isSingleCode.bind(this);
        this.updateSums = this.updateSums.bind(this);
        props.data.forEach(d=>{
          this.calcWeightOrQuantity(d);   
        });        
    }      



    tell(txt, row) {      
        setDataForExpansion(txt, row, this.props.apiToken, this);
    }
    gettProductProp(index, prop)
    {
      let product=this.getProduct(index);
      return product && product.value && product.value[prop];
    }

    getProduct(index)
    {
        let obj=this.props.productCodes.find(p=>p.PRODUCT_CODE==this.state.data[index].PRODUCT_CODE);
        let tmp= obj && {label:obj.PRODUCT_CODE +' - '
        + obj.GRADE_DESCRIPTION + ' - '
        + Convert.AddSymbol({ check : obj.BASIS_WEIGHT_UC}) + obj.BASIS_WEIGHT_UC + Convert.TextTo({ value_metric : " g - ", value_imperial : " - " })
        + (obj.PT_DESCRIPTION==='RULL' ? obj.ROLL_WIDTH_UC : obj.FORMAT_UC) + Convert.TextTo({ value_metric : "mm", value_imperial : "in" })
        + ' - OD:' + obj.ROLL_DIAMETER_TARGET_UC + Convert.TextTo({ value_metric : "mm", value_imperial : "in" })
        , value:obj};
        return tmp;
    }

    getDeliverytimeMethod(row)
    {
      let obj=this.props.deliveryTimeCodes.find(p=>p.CODE== row.original.DELIVERYTIME_METHOD);
      let tmp= obj && {label:obj.DESCRIPTION, value:obj};
      return tmp;
    }

    getORDERED_BY(row)
    {
      return row.original.ORDERED_BY==='W' ? {label:'Weight',value:'W'} : row.original.ORDERED_BY === 'Q' ? {label:'Quantity',value:'Q'} : {label:'Meter',value:'M'}
    }

    isSingleCode(codes){
      let hit = 0;
      if(codes.fsc)
        hit++;
      if(codes.pefc)
        hit++;
      if(codes.cw_mark)
        hit++;
      return hit == 1 ? true : false;
    }

    addNewRow()
    {
      if (this.oktoAddAnotherRow(this))
      {
        let singleCode = this.isSingleCode(this.props.specialCodes);
        let texts=JSON.parse(JSON.stringify(this.props.itemTexts.filter(d=>d.USERDEFINED!='1')));
        let instr=JSON.parse(JSON.stringify(this.props.itemInstructions));
        this.state.data.push({PRODUCT_CODE:'',ORDERED_BY:'W', 
          FSC:singleCode ? this.props.specialCodes.fsc : singleCode, 
          PEFC:singleCode ? this.props.specialCodes.pefc : singleCode, 
          CW_MARK:singleCode ? this.props.specialCodes.cw_mark : singleCode, 
          DELIVERYTIME_METHOD: '4', Texts:texts,
          DELIVERYTIME_DATE:'', DELIVERYTIME_WEEK:'',DELIVERYTIME_TEXT:'', QUANTITY:0, WEIGHT_UC:0, PRICE_UNIT:this.props.priceUnit,
          UNIT_PRICE_COMMITTED:0, WEEK_OK:false, ORDER_ITEM_NUMBER:-1, Instructions:instr
        });
        this.setState({});
     }
    }

    oktoAddAnotherRow(self)
    {
      return (self.state.data.length==0 || self.state.data.filter(d=>d.PRODUCT_CODE==="").length===0);

    }




    clearAllExpAndTag(row)
    {
      let props=Object.getOwnPropertyNames(row.original);
      props.forEach(element => {
        if (element==='TAG' || element.startsWith('EXP_'))
        {
          delete row.original[element];
        }        
      });
    }


    clearCurrentExpandforAll() {
      let d = getFilteredData(this.reactTable.getRectTable());
      this.currentExpand = '';
      d.forEach(dt => {
          dt.TAG = undefined;
      });
    }

    getQuantityByWeight(weight, netweight){
      if(weight == 0)
        return 0;

      let tmp=(weight/netweight).toFixed(4);
      let calculated=parseFloat(tmp);
      let sum = Math.round(calculated);
      return sum < 1 ? 1 : sum;
    }
   

    calcWeightOrQuantity(datarow){
      let pCode=this.props.productCodes.find(p=>p.PRODUCT_CODE==datarow.PRODUCT_CODE);
      if (pCode && this.state.orderByType && (pCode.PT_DESCRIPTION==='RULL' || pCode.PT_DESCRIPTION==='ARK'))
      {
        //let w=pCode.PT_DESCRIPTION==='RULL' ? pCode.NET_WEIGHT : pCode.BASIS_WEIGHT;
        let w = datarow.NET_WEIGHT_UC ? datarow.NET_WEIGHT_UC : pCode.NET_WEIGHT_UC;
        let factor=pCode.FACTOR || 1;
        if (pCode.PT_DESCRIPTION==="RULL"){
          
          let palletQuantity = datarow.ROLLS_PER_PALLET && datarow.ROLLS_PER_PALLET > 0 ? datarow.ROLLS_PER_PALLET
          : pCode.ROLLS_PER_PALLET != null && pCode.ROLLS_PER_PALLET > 0 ? pCode.ROLLS_PER_PALLET : 1;
          let rollLengthTarget = datarow.ROLL_LENGTH_TARGET_UC ? datarow.ROLL_LENGTH_TARGET_UC : pCode.ROLL_LENGTH_TARGET_UC;
          if (datarow.ORDERED_BY==='Q'){   
            datarow.WEIGHT_UC = (w*datarow.QUANTITY/palletQuantity).toFixed(1);
          }
          else if (datarow.ORDERED_BY==='W')        {
            datarow.QUANTITY=this.getQuantityByWeight(datarow.WEIGHT_UC, (w/palletQuantity));//Math.ceil(datarow.WEIGHT/w);
          }
          else if(datarow.ORDERED_BY==='M'){
            datarow.WEIGHT_UC = (((w/palletQuantity)/rollLengthTarget) * datarow.QUANTITY).toFixed(1);
            datarow.ART_QUANTITY = this.getQuantityByWeight(datarow.WEIGHT_UC, (w/palletQuantity));
            //((NET_WEIGHT/ROLLS_PER_PALLET)/ROLL_LENGTH_TARGET) * CUST_QUANTITY

          }
        }
        else{
          if (factor<1){
            factor=1;
          }
          if(!w)
            w=(pCode.SHEET_WIDTH_UC/factor)*(pCode.SHEET_HEIGHT_UC/factor)*(pCode.BASIS_WEIGHT_UC/factor)*pCode.SHEET_TOTAL_NUMBER;
          if (datarow.ORDERED_BY==='Q'){   
            datarow.WEIGHT_UC=(w*datarow.QUANTITY).toFixed(1);
          }
          else if (datarow.ORDERED_BY==='W')        {
            datarow.QUANTITY=this.getQuantityByWeight(datarow.WEIGHT_UC,w);//Math.ceil(datarow.WEIGHT/w);
          }
        }        
      }
       else
       {
          datarow.WEIGHT_UC=0;
          datarow.QUANTITY=0;
       }
      if(datarow.WEIGHT_UC != '' && datarow.QUANTITY != ''){
        this.updateSums(datarow);
      }

      /*
      J_W

      datarow = row.original
      .      datarow.WEIGHT
      .      datarow.NET_WEIGHT
      .      datarow.ROLL_LENGTH_TARGET

      pCode = this.props.productCodes
      .      pCode.NET_WEIGHT
      .      pCode.BASIS_WEIGHT      
      .      pCode.ROLL_LENGTH_TARGET
      .      pCode.SHEET_WIDTH
      .      pCode.SHEET_HEIGHT
    
      */

      console.log(" ");
      console.log("PEEK START: - - - - - - - - - - -");
      console.log(" ");
      console.log("datarow.WEIGHT                : " + datarow.WEIGHT);
      console.log("datarow.WEIGHT_UC             : " + datarow.WEIGHT_UC);
      console.log("datarow.NET_WEIGHT            : " + datarow.NET_WEIGHT);
      console.log("datarow.NET_WEIGHT_UC         : " + datarow.NET_WEIGHT_UC);
      console.log("datarow.ROLL_LENGTH_TARGET    : " + datarow.ROLL_LENGTH_TARGET);
      console.log("datarow.ROLL_LENGTH_TARGET_UC : " + datarow.ROLL_LENGTH_TARGET_UC);
      console.log(" ");
      console.log("pCode.NET_WEIGHT              : " + pCode.NET_WEIGHT);
      console.log("pCode.NET_WEIGHT_UC           : " + pCode.NET_WEIGHT_UC);
      console.log("pCode.BASIS_WEIGHT            : " + pCode.BASIS_WEIGHT);
      console.log("pCode.BASIS_WEIGHT_UC         : " + pCode.BASIS_WEIGHT_UC);
      console.log("pCode.ROLL_LENGTH_TARGET      : " + pCode.ROLL_LENGTH_TARGET);
      console.log("pCode.ROLL_LENGTH_TARGET_UC   : " + pCode.ROLL_LENGTH_TARGET_UC);
      console.log("pCode.SHEET_WIDTH             : " + pCode.SHEET_WIDTH);
      console.log("pCode.SHEET_WIDTH_UC          : " + pCode.SHEET_WIDTH_UC);
      console.log("pCode.SHEET_HEIGHT            : " + pCode.SHEET_HEIGHT);
      console.log("pCode.SHEET_HEIGHT_UC         : " + pCode.SHEET_HEIGHT_UC);
      console.log(" ");
      console.log("PEEK END: - - - - - - - - - - -");
      console.log(" ");

    }

    updateSums(datarow){
      if(this.reactTable){
        let data = this.reactTable.props.data;
        this.state.weightTotal = getSum(data, "WEIGHT_UC");
        this.state.quantityTotal = getSum(data, "QUANTITY");
        this.props.parentRefresh();
      }
      else if(datarow){
        this.state.weightTotal = parseFloat(this.state.weightTotal) + parseFloat(datarow.WEIGHT_UC);
        this.state.quantityTotal = parseFloat(this.state.quantityTotal) + parseFloat(datarow.QUANTITY);
      }
      else{
        this.props.parentRefresh();
      }
    }

    updateDates(datarow){
      //console.log('calling updateDates');
      let m=datarow['DELIVERYTIME_METHOD'];
      let w=datarow['DELIVERYTIME_WEEK'];
      let d=datarow['DELIVERYTIME_DATE'];
      if (m=='1' || m=='2'){
        datarow['DELIVERYTIME_WEEK']=null;
      }
      else if (m=='3' || m=='4'){
        if (datarow.WeekComponent && datarow.WeekComponent)
        {
          this.props.parentRefresh(); 
          datarow.WEEK_OK=datarow.WeekComponent.checkValidity();
          this.props.parentRefresh(); 
        }
        datarow['DELIVERYTIME_DATE']=null;
      }
    }

    getFirstProductWareHouse(data,products)
    {
      // console.log('data',data);
      // console.log('products',products);
      let pCode=data && data.length>0 && data.find(p=>p.PRODUCT_CODE && p.PRODUCT_CODE.length>1);
      if (pCode)
      {
        let result=products.find(p=>p.PRODUCT_CODE==pCode.PRODUCT_CODE);
        return result && result.MILL_CODE;
      }
      return undefined;
    }
  
    help() {
      alert('\u2795 Adds an order item\r\u2796 Removes an order item (after a confirmation question)\r \u25BC For extra information');
    }

    getWeek(value){
      if (value&& value.length==2 && parseInt(value)==value && value>0 && value<54)
      {
        var currentWeekNumber = moment(new Date()).isoWeek();
        
        var year=(new Date().getFullYear()+((currentWeekNumber>=value)?1:0)).toString();
        return year+('0' + value).slice(-2);
      }
      else
       return value;
    }

    getcolumns() {    
        
        let self= this;
        let dc=this.props.deliveryTimeCodes;
        let styleforNumbers={width:'84px'};

        let deliveryTimeCodes=dc ? dc.map(d=> ( {label: d.DESCRIPTION, value: d})) : [];
        // console.log('deliveryTimeCodes',deliveryTimeCodes);
        
        const { data } = this.state;
        let millcode = this.getFirstProductWareHouse(data, this.props.productCodes);
        let c = millcode==undefined ? this.props.productCodes : this.props.productCodes.filter(p=>p.MILL_CODE===millcode);   
        
        let productCodes = c ? c.map(f => ( {label: f.PRODUCT_CODE +' - '
        + f.GRADE_DESCRIPTION + ' - '
        + Convert.AddSymbol({ check : f.BASIS_WEIGHT_UC}) + f.BASIS_WEIGHT_UC + Convert.TextTo({ value_metric : "g - ", value_imperial : " - " }) + (f.GRADE_CODE.includes('EL') ? f.THICKNESS + ' μm - ': '')
        + (f.PT_DESCRIPTION==='RULL' ? f.ROLL_WIDTH_UC : f.FORMAT_UC) + Convert.TextTo({ value_metric : "mm", value_imperial : "in" })
        + ' - OD:' + f.ROLL_DIAMETER_TARGET_UC + Convert.TextTo({ value_metric : "mm", value_imperial : "in" })
        , value: f})) : [];
        
        let isCreator = hasGrant(Grants.TYPES.Order_CreateOrder);
        let plusStyle= this.oktoAddAnotherRow(this)  ? {color:'black'} : {color:'gray'};
        return [          
          {            
            Header: "Product",
            headerStyle: { background: '#EEEEEE' },
            columns: [
              {
                Header: props => <FontAwesome className="handy" name="question-circle" onClick={() => {this.help()}}/>, 
                maxWidth:35,
                id:'newRec',
                sortable:false,
                filterable:false,
                resizable:false,
                textAlign: "center",
                id:'orderItemNumber',
                Cell: row => (
                  <div disabled = {row.original.ORDER_ITEM_STATUS === "B"} style={{textAlign: "center"}}>{row.original.ORDER_ITEM_NUMBER==-1 ? "" : row.original.ORDER_ITEM_NUMBER}</div>
                )
              },
              {
                Header: props => isCreator ? <FontAwesome className="handy" name="plus" disabled={isCreator === false} onClick={() => { this.props.disabled === false && this.addNewRow()}} style={plusStyle}/> : '', 
                maxWidth: 20,
                filterable: false,
                sortable: false,
                id:'addRemoveRow',
                textAlign: "center",
                resizable:false,
                Cell: (props, row) => <span style={{textAlign: "center"}}>                 
                    <FontAwesome className="handy" style={{textAlign: "center"}}  name="minus" onClick={
                () => { removeRow(data, props.row._original, this, this.updateSums,'Remove order item','Do you really want to remove this order item?', props.row._original.ORDER_ITEM_STATUS === "B")}}/></span>               
              },

              {
                expander: true,
                resizable:false,
                width: 35,
                id:'exp1',
                Expander: ({ isExpanded, ...row }) =>
                getExpander(row,'PRODUCT_CODE',this,isExpanded),
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                  userSelect: "none"
                },
              },
              {
                Header: "Product Code",
                maxWidth:500,
                minWidth:350,
                id:'prodCode',  
                  Cell: row => (
                      <Select isSearchable={true}
                      isDisabled={row.original.ORDER_ITEM_STATUS === "B"}
                      style={{ width: "100%" }}
                      isClearable={false}
                      options={productCodes}
                      menuContainerStyle={{ zIndex: 5 }}
                      value={this.getProduct(row.index)}
                      onChange={evt => {
                        if(!evt.value.PAPER_MACHINE){
                          this.dialog.showAlert(evt.value.PRODUCT_CODE + ' is missing a paper machine in product definition, contact Nordic Paper.');
                        }
                        else{
                          let t =productCodes.find(p=>p.label==evt.label)
                          row.original.PRODUCT_CODE=evt.value.PRODUCT_CODE;
                          row.original.MILL_CODE=evt.value.MILL_CODE;
                          row.original.IS_ACTIVE = evt.value.IS_ACTIVE;

                          row.original.ORDER_NUMBER = -1;
                          row.original.ORDER_ITEM_NUMBER = -1;
                          row.original.COPIED_FROM_ORDER_ITEM_NUMBER = null;
                          row.original.COPIED_FROM_ORDER_NUMBER = null;
                          row.original.QUANTITY = 0;
                          row.original.WEIGHT_UC = 0;
                          row.original.UNIT_PRICE_COMMITTED = 0;
                          row.original.PEFC = self.props.specialCodes.pefc;
                          row.original.FSC = self.props.specialCodes.fsc;
                          row.original.CW_MARK = self.props.specialCodes.cw_mark;
                          row.original.DELIVERYTIME_DATE = null;
                          row.original.DELIVERYTIME_TEXT = "";
                          row.original.DELIVERYTIME_WEEK = "";
                          row.original.CURRENCY_VALUE = self.props.currency;
                          this.calcWeightOrQuantity(row.original);
                          this.clearAllExpAndTag(row);
                          this.props.parentRefresh();
                          this.setState({});
                        }
                        //self.setState({['ProductCode_'+row.index]:t});
                      }}
                    />
                )
              },
              {
                Header: "Type",
                maxWidth:50,
                id:'type',
                Cell: row => (
                  <div>{this.gettProductProp(row.index,'PT_DESCRIPTION')}</div>
                )
              },
              {
                Header: "Grade Code",
                maxWidth:80,
                id:'Grade Code',
                Cell: row => (
                  <div>{this.gettProductProp(row.index,'GRADE_CODE')}</div>
                )
              },
              {
                Header: <Convert.TextTo value_metric={"Grammage"} value_imperial={"Basis weight"}/>,
                maxWidth:90,
                textAlign: "right",
                id:'BSW',
                Cell: row => (
                  <div><Convert.AddSymbol check={this.gettProductProp(row.index,'BASIS_WEIGHT_UC')}/>{this.gettProductProp(row.index,'BASIS_WEIGHT_UC')} </div>
                )
              },
              {
                expander: true,
                Header:'Texts',
                width: 50,
                id:'expTexts',
                resizable:false,
                show:hasGrant(Grants.TYPES.Order_ModifyOrderTexts),
                Expander: ({ isExpanded, ...row }) =>
                getExpander(row,'ITEMTEXTS',this,isExpanded),
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                  userSelect: "none"
                },
              },
            ]
          },
          {
          Header: "Order info",
          headerStyle: { background: '#EEEEEE' },
          columns: [
            {
              Header: 'Currency',
              maxWidth:60,
              id:'currency',
              accessor:'CURRENCY_VALUE'
            },
            {
              Header: 'Sales price',
              maxWidth:94,
              id:'salesPrice',
              Cell: row => (
                <input type="number" className="form-control input-sm"
                  disabled={hasGrant(Grants.TYPES.Order_EditPrice) == false || row.original.ORDER_ITEM_STATUS === "B"}
                  step="0.0001"
                  min="0"
                  style={styleforNumbers}
                  onChange={ (e)=>{
                    row.original.UNIT_PRICE_COMMITTED=e.target.value;
                    this.calcWeightOrQuantity(row.original);     
                    this.props.parentRefresh(); 
                    self.setState({});
                  } }
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  value={row.original.UNIT_PRICE_COMMITTED} >
                </input>
              )       
            },
            {
              Header: 'Price unit',
              maxWidth:80,
              id:'priceUnit',
              accessor:'PRICE_UNIT'
            },
            getBoolColumn('FSC','FSC',40,this),
            getBoolColumn('PEFC','PEFC',60,this),
            getBoolColumn('CW','CW_MARK',40,this),
            {
              Header: "By",
              id:'by',
              maxWidth:120,
              Cell: row => (
                <Select isSearchable={true}
                  isDisabled = {row.original.ORDER_ITEM_STATUS === "B"}
                  style={{ width: "100%" }}
                  isClearable={false}
                  options={this.state.orderByType}
                  value={this.getORDERED_BY(row)}
                  onChange={evt => {
                    row.original.ORDERED_BY=evt.value;
                    this.calcWeightOrQuantity(row.original);
                    this.props.parentRefresh(); 
                    self.setState({});
                  }}
                />
              )
            },
            {
              Header: 'Quantity',
              accessor: "QUANTITY",
              maxWidth:94,
              id:'Quantity',
              filterMethod: filterNumber,
              Cell: row => (
                <input type="number" className="form-control input-sm"
                  disabled={row.original.ORDERED_BY === 'W' || row.original.ORDER_ITEM_STATUS === "B"}
                  step="0.1"
                  min="0"
                  style={styleforNumbers}
                  onChange={ (e)=>{       
                    row.original.QUANTITY=e.target.value;     
                    this.calcWeightOrQuantity(row.original);
                    this.props.parentRefresh(); 
                    self.setState({});
                    this.updateSums();
                  } }
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  value={row.original.QUANTITY} >
                </input>
              ),
              Footer: (
                <span>
                  <strong>{this.state.quantityTotal}</strong>
                </span>
              )       
            },
            {
              Header:  <Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/>,
              accessor: "WEIGHT_UC",
              maxWidth:94,
              id:'Weight',
              filterMethod: filterNumber,
              Cell: row => (
                <input type="number"  className="form-control input-sm"
                  disabled={row.original.ORDERED_BY!='W' || row.original.ORDER_ITEM_STATUS === "B"}
                  style={styleforNumbers}
                  step="0.001"
                  min="0"
                  onChange={ (e)=>{       
                    row.original.WEIGHT_UC=e.target.value;
                    this.calcWeightOrQuantity(row.original);
                    this.props.parentRefresh(); 
                    self.setState({});
                    this.updateSums();
                  } }
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  value={row.original.WEIGHT_UC} >
                </input>
              ),
              Footer: (
                <span>
                  <strong>{this.state.weightTotal}</strong>
                </span>
              )  
            },
          ]
          },
          {
            header: "Delivery Time",
            columns:[
              {
                Header: "Exmill week",
                maxWidth:90,
                minWidth:90,
                id:"week",
                Cell: row => (
                  <input type="input"
                    disabled = {row.original.ORDER_ITEM_STATUS === "B"}
                    ref={(input)=>{row.original.WeekComponent=input}} 
                    pattern="20[1-9][0-9]([0][1-9]|[1-4][0-9]|5[0-3])"
                    placeholder="WW"
                    autoComplete="false"
                    className="week form-control input-sm"
                    required={(row.original.DELIVERYTIME_METHOD==3 || row.original.DELIVERYTIME_METHOD==4)}
                    
                    onChange={ (e)=>{ 
                      row.original['DELIVERYTIME_WEEK']=this.getWeek(e.target.value);
                      if (e.target.value && e.target.value.length==2 && row.original.WeekComponent){
                        // Ugly fix so we can read the new calculated value
                        let self2=this;
                        setTimeout(()=>{
                          self2.updateDates(row.original);                       
                          self.setState({});
                        }); 
                      }
                      else{
                        this.updateDates(row.original);                       
                        self.setState({});  
                      }
                    } }

                    value={row.original['DELIVERYTIME_WEEK'] ||''} ></input>
                )
              },
                getTextColumn('Delivery date text','DELIVERYTIME_TEXT','200px',this, null, 45)
            ]
          }
        ];
    }
    updateAllDates(data){ 
      if (data)
      {
        data.forEach(d=>{this.updateDates(d)});
      }
    }
    render()
    {
        let c = this.props.productCodes; 
        let productCodes = c ? c.map(f => ( {label: f.PRODUCT_CODE, value: f.PRODUCT_CODE})) : [];
        const { data } = this.state;
        let self=this;
        
        return ( 
          <div>  
          <Dialog ref={(el) => { this.dialog = el }} />
          <NPReactTable
            onFetchData={(state, instance) => {
              this.updateAllDates(data);
            }}
            getTdProps={(state, rowInfo, column, instance) => {
              return {
                style: {
                  overflow: 'visible'                
                }
              }
            }}
            className="margin-top-5 np-react-table"
            data={data}
            ref={(r) => { this.reactTable = r }}
            showPagination={false}
            showPageSizeOptions={false}
            minRows={5} 
            columns={this.getcolumns()}
            defaultPageSize={10000}
            // Controlled props
            sorted={this.state.sorted}
            page={this.state.page}
            pageSize={this.state.pageSize}
            expanded={this.state.expanded}
            resized={this.state.resized}  
            onResizedChange={resized => { this.setState({ resized }) } }
            onPageChange={
              page => {
                this.clearCurrentExpandforAll();
                this.setState({ page, expanded: {} });
              }

            }
            onPageSizeChange={(pageSize, page) => {
                this.clearCurrentExpandforAll();
                this.setState({ page, pageSize, expanded: {} });
              }
            }
            SubComponent={
              row => {
                let r = row.original;
                let t = 'EXP_' + r.TAG;
                if (r.TAG && r.TAG !== '' && r[t]) {
                  return r[t];
                }
              }
            }
          />
        </div>
        );
    }
}

export default OrderItems;